import { defineComponent as S, computed as r, ref as y } from "vue";
import { merge as _, cloneDeep as z } from "lodash-es";
import { getFirstOfferAlternatives as D, getPriceFormatted as c, getEnergyEfficiencyProduct as F } from "@i22/rocket";
import H from "./td-longtail-vue-components76.js";
import R from "./td-longtail-vue-components18.js";
import w from "./td-longtail-vue-components48.js";
import Y from "./td-longtail-vue-components264.js";
import G from "./td-longtail-vue-components32.js";
const Q = /* @__PURE__ */ S({
  __name: "offer-tile",
  props: {
    offer: { default: void 0 },
    index: { default: void 0 },
    tagTitle: { default: "h2" },
    linkTag: { default: "a" },
    priceOptions: { default: void 0 },
    noTextBrand: { type: Boolean, default: !1 },
    isHighlight: { type: Boolean },
    highlightContent: { default: void 0 },
    hideVariants: { type: Boolean, default: !1 },
    hideContract: { type: Boolean },
    hideEnergyLabel: { type: Boolean },
    limitColorVariants: { default: void 0 },
    card: { default: void 0 },
    lazy: { type: Boolean },
    imageIndex: { default: 0 }
  },
  setup(b, { expose: O }) {
    const e = b, o = r(
      () => (
        // @ts-ignore
        D(e?.offer?.productAlternatives || [])
      )
    ), l = y(
      e.offer?.product?.articleNumber || void 0
    ), f = r(() => !o.value?.properties || !l.value ? e.offer : o.value.properties.flatMap((a) => a.items || []).find((a) => a?.offer?.product?.articleNumber === l.value)?.offer || e.offer), s = r(
      () => e.offer?.product?.bundle && "bundledProducts" in e.offer.product && e.offer.product.bundledProducts?.length
    ), i = r(() => {
      if (!e.offer?.product) return [];
      const t = "bundledProducts" in e.offer.product ? e.offer.product.bundledProducts : void 0;
      if (!t) return e.offer?.product?.family?.brand?.name || [];
      const a = t.map(({ family: x }) => x?.brand?.name).filter(Boolean);
      return [...new Set(a)];
    }), d = r(() => e.offer?.product?.family && "model" in e.offer.product.family ? e.offer?.product?.family?.model : s.value ? i.value.reduce(
      // @ts-ignore
      (t, a) => t?.replaceAll(a, ""),
      e.offer?.product?.family?.name || ""
    ) : e.offer?.product?.family?.name || ""), u = y(void 0), p = r(() => u.value ? u.value : f.value?.product?.slug ? `/geraete/${f.value.product.slug}` : ""), E = r(() => {
      const t = {
        tag: e.linkTag,
        size: "small",
        href: p.value,
        heading: {
          tag: e.tagTitle,
          text: d.value,
          align: "left",
          itemprop: "name",
          spacesBottomRem: !0,
          size: "sm"
        }
      };
      return _(t, z(e.card)), t;
    }), N = r(() => s.value ? i.value.length > 1 ? "" : i.value[0] || "" : i.value), m = r(() => e.offer?.product?.articleNumber || ""), n = r(() => f.value?.prices || []), v = r(
      () => c(n.value, "DEFAULT", "ONETIME", e.priceOptions)
    ), g = r(
      () => c(n.value, "WAS", "ONETIME", e.priceOptions)
    ), T = r(
      () => c(n.value, "DEFAULT", "MONTHLY", e.priceOptions)
    ), P = r(
      () => c(n.value, "WAS", "MONTHLY", e.priceOptions)
    ), B = r(() => o.value?.variants?.COLOR?.items), L = r(() => o.value?.variants?.STORAGE?.items), V = r(() => o.value?.variants?.SIZE?.items), A = r(() => o.value?.variants?.MEMORY?.items), h = r(() => (e.offer?.product?.availability?.stock || 0) > 0), M = r(() => e.offer?.product?.availability?.provider || ""), C = r(() => {
      const t = [];
      return e.isHighlight && t.push("offer-tile--highlight"), t;
    }), I = r(() => {
      if (!(e.hideEnergyLabel || !e.offer?.product))
        return F(e.offer.product);
    }), k = ({ variant: t }) => {
      t.offer?.product?.articleNumber && (l.value = t.offer.product.articleNumber), u.value = t.path;
    };
    return O({
      title: d,
      price: v,
      wasPrice: g,
      offerLink: p,
      hasStock: h,
      transformedAlternative: o,
      articleNumber: m
    }), { __sfc: !0, props: e, transformedAlternative: o, currentVariantArticleNumber: l, currentVariant: f, isBundle: s, brandName: i, title: d, manualLink: u, offerLink: p, extendedCard: E, brandNameDisplay: N, articleNumber: m, currentVariantPrices: n, price: v, wasPrice: g, priceMonthly: T, wasPriceMonthly: P, colorVariantOffers: B, storageVariants: L, sizeVariants: V, memoryVariants: A, hasStock: h, provider: M, articleClass: C, energyLabel: I, selectVariant: k, Card: H, GoliathImageElement: R, EnergyLabel: w, OfferTileVariant: Y, Prices: G };
  }
});
export {
  Q as default
};
